const host = 'https://europe-west2-prj-tca-npd-0d74.cloudfunctions.net';

const dashboards = {
  fixedincome: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `22839260-2cb5-4cf1-885a-15b55ea3a8c7`,
      tradedetails: `58f090aa-da99-4f12-8242-11c145769d06`,
      outliers: `6bb93637-3008-4965-b433-05801054b10d`,
      pmoverview: `6bf6703e-e421-40ab-9ac1-0a12f78f08a2`,
      traderoverview: `150d0a28-7866-4624-aeb7-b0d10eb7395c`,
    },
    worksheetId: 'a8fef57d-3225-4910-8364-6d671d430304',
  },
  fx: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `ba380512-4378-46b6-a302-3259a6bc0d5e`,
      tradedetails: `46de0044-1d57-495c-aacf-1a902216a869`,
      outliers: `e6402494-146a-4654-972a-5a3bbc57afe4`,
      pmoverview: `na`,
      traderoverview: `na`,
    },
    worksheetId: 'b53c538b-2913-424a-a339-9d455ff797fa',
  },
  fxforward: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: `7ed1f30c-321e-4e54-9996-651dd75039a1`,
      tradedetails: `7efd3150-e94d-4ecd-90bb-7659db96a764`,
      outliers: `816866e6-d1e8-4445-bbec-7022f9645785`,
      pmoverview: `na`,
      traderoverview: `na`,
    },
    worksheetId: 'c8cb6e06-0e62-432f-b94a-87380e35c753',
  },
  // FX Swap Trade Details, Jitto only: its route id is its embedded uuid in the shared map
  // (src/config/jittoDashboards.json), as in production.
  fxswap: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: 'na',
      tradedetails: '3a37eef7-1625-5d3c-9bd3-97d8c60c9cdf',
      outliers: 'na',
      pmoverview: 'na',
      traderoverview: 'na',
    },
  },
  irs: {
    names: {
      summary: 'Summary',
      tradedetails: 'Trade Details',
      outliers: 'Outliers',
      pmoverview: 'PM Overview',
      traderoverview: 'Trader Overview',
    },
    ids: {
      summary: '5f6981b9-d924-44fe-bec5-ec0c44298d85',
      tradedetails: 'cfe8c345-f161-472c-a2e6-fc74f0672f7c',
      outliers: '6db2e0ec-ebe5-4e5f-9f9e-8eaa25defe90',
      pmoverview: 'na',
      traderoverview: 'na',
    },
    worksheetId: '538c7f74-dbcd-4b98-bb25-37ae7e4d53b0',
  },
};

const config = {
  uploadsItemsPerPage: 7,
  uploadsPaginationItems: 10,
  uploadsPreviewColumns: 8,
  bepActiveFlag: true,
  repLinearActiveFlag: true,
  fepSpotActiveFlag: true,
  fepForwardsActiveFlag: true,
  fepNonLinearActiveFlag: false,
  endpoints: {
    uploadDetails: `${host}/upload-details`,
    getUploadUrl: `${host}/get-upload-url`,
    uploads: `${host}/uploads`,
    mapUpload: `${host}/map-upload`,
    downloadFile: `${host}/download-file`,
    deleteIngest: `${host}/delete-ingest`,
    cancelIngest: `${host}/cancel-ingest`,
    approveVerificationReport: `${host}/approve-verification-report`,
    requestAccount: `${host}/request-account`,
    getUserData: `${host}/get-user-data`,
    verifyUserToken: `${host}/verify-user-token`,
    getThoughtSpotToken: `${host}/get-thoughtspot-token`,
    getJittoEmbedToken: `${host}/get-jitto-embed-token`,
    preferences: `${host}/user-preferences`,
    getLogUrl: `${host}/get-log-url`,
    mappingAdmin: `${host}/mapping-admin`,
    mappingAdminValues: `${host}/mapping-admin-values`,
    getMappingAuditTrail: `${host}/mapping-audit-trail`,
  },
  uploadValidationPollInterval: 5000,
  oktaAccountManagementLink:
    'https://parameta-accounts.okta.com/enduser/settings?fromLogin=true',
  // Jitto embed (ANS-545): on in NPD. A dashboard with an embedded uuid in
  // config/jittoDashboards.json renders from Jitto and every other one shows a notice;
  // nothing asks ThoughtSpot (no ThoughtSpot embed, AI Assistant, dashboard builder or
  // logout). When off, all of it is ThoughtSpot.
  jittoEmbedActiveFlag: true,
  // NPD Jitto's embed host, hosted by JamLabs (jitto-analyze deploy/tenants/tpicap/npd):
  // @jitto/analyze-embed frames only <this>/embed (ANS-678).
  jittoEmbedOrigin: 'https://embed.tpicap-tca-npd.jitto.jamlabs.com',
  // Jitto applies host filters (filters on mount, setFilters): @jitto/analyze-embed 0.3.0, and
  // tca-npd runs jitto-analyze#540 with EMBED_HOST_FILTERS on and single_choice listed (29 Oct,
  // ANS-801). The currency picker drives the dashboard's Ccy filter.
  jittoHostFilters: true,
  thoughtSpotHost: 'https://parameta.thoughtspot.cloud',
  authProvider: 'okta',
  okta: {
    issuer: 'https://parameta-accounts.okta.com/oauth2/default',
    clientId: '0oa131qon7hilhvva417',
    pkce: false,
    tokenManager: {
      storage: 'cookie',
    },
    cookies: {
      sessionCookie: true,
    },
  },
  fxCurrencies: [
    'USD',
    'CAD',
    'CNY',
    'CHF',
    'AUD',
    'JPY',
    'EUR',
    'GBP',
    'NZD',
    'HKD',
    'SEK',
    'SGD',
  ].sort(),
  requestAccountActionURL:
    'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
  requestAccountRetURL: 'https://tca.dhb-npd.tpicapcloud.com/requestaccount',
  dashboards,
};

export default config;
